// extracted by mini-css-extract-plugin
export default {"accordionWrapper":"accordion-module--accordion-wrapper--e730e","accordionContainer":"accordion-module--accordion-container--cbc49"};